import { getTokenBrandData } from '../brandIdentifiers';
import type { BrandSource } from './types';
import { namesABrand } from './types';

const asString = (value: unknown): string | undefined => {
  if (typeof value === 'string' && value) return value;
  if (typeof value === 'number') return String(value);
  return undefined;
};

// gloss
export const tokenBrandSource: BrandSource = {
  name: 'token',
  resolve: () => {
    const claims = getTokenBrandData();
    const identifiers = {
      uuid: asString(claims?.brandUuid),
      brandID: asString(claims?.brandID) ?? asString(claims?.brandId),
      code: asString(claims?.brand),
    };

    return namesABrand(identifiers) ? identifiers : null;
  },
};
